import { getCurrentInstance } from "vue";
import saveOrDiscardModal from "@/components/modals/saveOrDiscardModal.vue";
const SaveOrDiscard = {
    install(app, options = {}) {
        app.provide("$saveOrDiscard", (opt) => {
            const baseOpt = {
                parent: getCurrentInstance(),
                component: saveOrDiscardModal,
                trapFocus: true,
                events: {
                    onDiscard: opt.onDiscard,
                    onSave: opt.onSave
                }
            };
            app.config.globalProperties.$oruga.modal.open({
                ...baseOpt,
                props: opt
            });
        });
    }
};
export default SaveOrDiscard;
